import TemplateSection from './TemplateSection';

export default TemplateSection;
